/** @typedef {import("./resources").Resource} Resource */
import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link, useNavigate, useParams} from "react-router-dom";
import {Alert, Container, Spinner} from "reactstrap";
import ResourceForm from "./ResourceForm";

const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

/** @param {{resource: Resource}} props */
const ResourceEdit = ({resource}) => {
    const {singular, url, path, fields} = resource;
    const {id} = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState(/** @type {Record<string, any>|null} */ (null));
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const itemUrl = `${url}${encodeURIComponent(id)}/`;

    useEffect(() => {
        const controller = new AbortController();
        setLoading(true);
        setError(null);
        setData(null);

        axios
            .get(itemUrl, {signal: controller.signal})
            .then(({data}) => setData(data))
            .catch((err) => {
                if (axios.isCancel(err)) return;
                setError(
                    err.response?.status === 404
                        ? `${capitalize(singular)} não encontrado.`
                        : `Não foi possível carregar o ${singular}.`
                );
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });

        return () => controller.abort();
    }, [itemUrl, singular]);

    return (
        <Container className="mt-4 mb-5" style={{maxWidth: 640}}>
            <Link to={`${path}/${id}`}>&larr; Voltar</Link>
            <h3 className="mt-3 mb-3">Editar {singular}</h3>
            {loading && (
                <div className="text-center">
                    <Spinner />
                </div>
            )}
            {error && <Alert color="danger">{error}</Alert>}
            {data && (
                <ResourceForm
                    fields={fields}
                    initial={data}
                    submitLabel="Salvar alterações"
                    onCancel={() => navigate(`${path}/${id}`)}
                    onSubmit={async (payload) => {
                        await axios.put(itemUrl, payload);
                        navigate(`${path}/${id}`, {replace: true});
                    }}
                />
            )}
        </Container>
    );
};

export default ResourceEdit;
